<template>
	<div>
		<b-card title="绝技" no-body>
			<b-card-header header-tag="nav">
				<b-nav card-header tabs>
					<b-nav-item to="/wonder/yjj/p" exact exact-active-class="active">易筋经</b-nav-item>
					<b-nav-item to="/wonder/yjj/j" exact exact-active-class="active">精选</b-nav-item>
					<b-nav-item to="/wonder/yjj/g" exact exact-active-class="active">概念</b-nav-item>
					<b-nav-item to="/wonder/yjj/i" exact exact-active-class="active">行业</b-nav-item>
					<b-nav-item to="/wonder/yjj/ml" exact exact-active-class="active">推演</b-nav-item>
					<b-nav-item to="/wonder/topic/table" exact exact-active-class="active">题材表格</b-nav-item>
					<!-- <b-nav-item to="/wonder/jyjy" exact exact-active-class="active">九阳神功</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/98" exact exact-active-class="active">98</b-nav-item> -->
					<!-- <b-nav-item to="/wonder/99" exact exact-active-class="active">99</b-nav-item> -->
				</b-nav>
			</b-card-header>
			<b-card-body>
				<router-view></router-view>
			</b-card-body>
		</b-card>
	</div>
</template>

<script>	
	export default {
		data() {
			return {
			}
		},
		components: {
			
		},
		methods: {

		}
	}
</script>

<style>
</style>
